import React, {useEffect, useRef, useState} from 'react';
import AppHeaderStyles from './AppHeader.module.scss';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {useAppSelector, useMobile} from "../../utils";

const AppHeader = () => {
    const isMobile = useMobile();
    const navigate = useNavigate();
    const location = useLocation();
    const logoRef = useRef<HTMLAnchorElement>(null);
    const [isHovered, setIsHovered] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const cartItems = useAppSelector((state) => state.cartSlice.cart);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleLogoInteraction = () => {
        if (isMobile) {
            setIsHovered(true);
            const timer = setTimeout(() => {
                setIsHovered(false);
            }, 1000);
            return () => clearTimeout(timer);
        }
    };

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (logoRef.current && !logoRef.current.contains(e.target as Node)) {
                setIsHovered(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleOpenModal = () => {
        navigate('/cart');
    };

    useEffect(() => {
        if (isMenuOpen) {
            document.body.classList.add('bodyNoScroll');
        } else {
            document.body.classList.remove('bodyNoScroll');
        }
    }, [isMenuOpen]);


    return (
        <header>
            <nav className={AppHeaderStyles.nav}>
                <Link
                    ref={logoRef}
                    to="/"
                    onMouseEnter={!isMobile ? () => setIsHovered(true) : undefined}
                    onMouseLeave={!isMobile ? () => setIsHovered(false) : undefined}
                    onClick={isMobile ? handleLogoInteraction : undefined}
                    className={AppHeaderStyles.logoContainer}
                >
                    {isHovered ? (
                        <video
                            autoPlay
                            loop
                            muted
                            style={{width: '105%', height: '105%', objectFit: 'cover'}}
                        >
                            <source src="/logoGif.gif.mp4" type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <img
                            src="/logo.png"
                            alt="Логотип"
                            style={{width: '100%', height: '100%'}}
                        />
                    )}
                </Link>

                <div className={AppHeaderStyles.navRight}>
                    {/* Десктопные ссылки */}
                    <div className={AppHeaderStyles.desktopLinks}>
                        <Link to="/">Магазин</Link>
                        <Link to="/events">События</Link>
                        <Link to="/about">Контакты</Link>
                    </div>

                    <div className={AppHeaderStyles.rowColumn}>
                        <a
                            className={AppHeaderStyles.rowColumnLinks}
                            href="https://vk.com/epatazhnost"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img className={AppHeaderStyles.link} src="/vk.svg" alt="VK"/>
                        </a>
                        <a
                            className={AppHeaderStyles.rowColumnLinks}
                            href="https://t.me/epatazhnost"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img className={AppHeaderStyles.link} src="/tg.svg" alt="Telegram"/>
                        </a>
                        <a
                            className={AppHeaderStyles.rowColumnLinks}
                            href="https://www.youtube.com/@epatazhnost"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img className={AppHeaderStyles.link} src="/yt.svg" alt="YouTube"/>
                        </a>
                    </div>
                </div>
                {isMobile ? (<div className={AppHeaderStyles.cartWrapper} onClick={handleOpenModal}>
                    <img src="/cart.svg" alt={'cart'} className={AppHeaderStyles.cartItem}/>
                    {cartItems.length > 0 && (
                        <div className={AppHeaderStyles.cartBadge}>
                            {cartItems.length}
                        </div>
                    )}
                </div>) : null
                }


                {/* Бургер-меню */}
                <div
                    className={AppHeaderStyles.burger}
                    onClick={toggleMenu}
                >
                    <img src="/burgerHeader.svg" alt="Меню"/>
                </div>

                {/* Мобильное меню */}
                {isMenuOpen && (
                    <>
                        <div
                            className={AppHeaderStyles.menuOverlay}
                            onClick={toggleMenu}
                        />
                        <div className={AppHeaderStyles.mobileMenu}>
                            <Link
                                to="/"
                                onClick={toggleMenu}
                                style={{
                                    fontWeight: location.pathname === '/' ? 'bold' : ''
                                }}
                            >
                                Магазин
                            </Link>
                            <Link
                                to="/events"
                                onClick={toggleMenu}
                                style={{
                                    fontWeight: location.pathname === '/events' ? 'bold' : ''
                                }}
                            >
                                События
                            </Link>
                            <Link
                                to="/about"
                                onClick={toggleMenu}
                                style={{
                                    fontWeight: location.pathname === '/about' ? 'bold' : ''
                                }}
                            >
                                Контакты
                            </Link>
                        </div>
                    </>
                )}
            </nav>
        </header>
    );
};

export default AppHeader;